export default {
  // Common / Navigation
  siteName: "CSSBuy Spreadsheet",
  siteSubtitle: "Centro de Recursos",
  nav: {
    home: "Início",
    categories: "Categorias",
    products: "Produtos",
    guides: "Guias",
    reviews: "Avaliações",
    shipping: "Envio",
    qc: "QC",
    sellers: "Vendedores",
    safety: "Segurança",
    shoppingGuide: "Guia de Compras",
    language: "Idioma",
  },
  cta: {
    explore: "Explorar CSSBuy Spreadsheet",
    guides: "Ver Guias CSSBuy",
    buyNow: "Comprar Agora",
    visitMain: "Visitar Site Principal",
    readMore: "Ler Mais",
    search: "Buscar",
  },
  footer: {
    disclaimer: "cssbuybr.quest é um recurso informativo independente e não é afiliado ou endossado pela CSSBuy, salvo indicação explícita.",
    links: {
      spreadsheet: "CSSBuy Spreadsheet",
      products: "Produtos",
      sellers: "Vendedores",
      guides: "Guias",
      reviews: "Avaliações",
      shipping: "Envio",
      qc: "QC",
      comparisons: "Comparações",
      safety: "Segurança",
      about: "Sobre",
      contact: "Contato",
      editorial: "Política Editorial",
      privacy: "Privacidade",
      terms: "Termos",
    },
    languages: "Idiomas",
  },
  // Home Page
  home: {
    hero: {
      h1: "CSSBuy Spreadsheet — Encontre Produtos, Vendedores e Guias CSSBuy",
      subtitle: "Explore o CSSBuy Spreadsheet para encontrar produtos, vendedores, informações de QC, guias de envio e dicas práticas para tornar suas compras internacionais mais simples e organizadas.",
      cta1: "Explorar CSSBuy Spreadsheet",
      cta2: "Comprar Agora",
      trust: "Guias atualizados • Recursos organizados • Informações práticas",
    },
    categories: {
      title: "Encontre rapidamente o que você procura",
      subtitle: "Navegue pelas categorias do CSSBuy Spreadsheet",
    },
    whatIs: {
      title: "O que é o CSSBuy Spreadsheet?",
      content: "O CSSBuy Spreadsheet é uma forma prática de organizar e descobrir produtos, vendedores e recursos relacionados ao CSSBuy. Nosso hub reúne listas, categorias, informações de QC, envio e guias em um único lugar para facilitar sua pesquisa. Se você está procurando tênis, hoodies, acessórios ou perfumes, o CSSBuy Spreadsheet ajuda você a navegar no mundo das compras internacionais com clareza e confiança.",
      cta: "Explorar a Lista CSSBuy Spreadsheet",
    },
    guides: {
      title: "Guias CSSBuy mais populares",
      items: [
        { title: "CSSBuy Review", desc: "Avaliação honesta dos recursos e da experiência da plataforma CSSBuy" },
        { title: "CSSBuy Shipping Cost", desc: "Guia completo de custos de envio e comparação de métodos" },
        { title: "Is CSSBuy Legit?", desc: "Análise de segurança e guia de verificação de confiança" },
        { title: "CSSBuy Warehouse", desc: "Como funciona o armazenamento e processamento no warehouse" },
        { title: "CSSBuy Coupon", desc: "Como encontrar e usar cupons de desconto CSSBuy" },
        { title: "CSSBuy QC Guide", desc: "Guia de fotos de QC e dicas de inspeção" },
      ],
    },
    whyUs: {
      title: "Por que usar nosso CSSBuy Spreadsheet?",
      content: "Nosso objetivo é organizar informações úteis em um formato simples de pesquisar. O conteúdo é estruturado por intenção de busca, categoria e tópico para ajudar você a encontrar rapidamente o recurso certo.",
      features: [
        { title: "Organizado", desc: "Todos os recursos organizados por categoria e intenção" },
        { title: "Prático", desc: "Dicas acionáveis e guias passo a passo" },
        { title: "Atualizado", desc: "Conteúdo e links atualizados regularmente" },
        { title: "Transparente", desc: "Sem avaliações falsas ou afirmações enganosas" },
      ],
    },
    articles: {
      title: "Últimos Artigos CSSBuy",
      subtitle: "Leia guias SEO detalhados e recursos",
    },
    faq: {
      title: "Perguntas Frequentes",
      items: [
        { q: "O que é o CSSBuy Spreadsheet?", a: "O CSSBuy Spreadsheet é um hub de recursos organizado que ajuda compradores a encontrar produtos, vendedores, guias de envio e informações de QC relacionadas ao CSSBuy em um só lugar." },
        { q: "O CSSBuy é legítimo e seguro?", a: "O CSSBuy é um serviço conhecido de compra por proxy. Nossos guias ajudam você a verificar segurança, conferir fotos de QC e seguir as melhores práticas para transações seguras." },
        { q: "Como encontro produtos no CSSBuy?", a: "Use os filtros de categoria ou a função de busca no CSSBuy Spreadsheet para navegar por produtos por tipo, vendedor ou faixa de preço." },
        { q: "O CSSBuy oferece cupons?", a: "Sim, o CSSBuy ocasionalmente oferece códigos de cupom e descontos. Nosso guia mostra onde encontrar os cupons CSSBuy mais recentes." },
      ],
    },
    safety: {
      title: "CSSBuy Safety Center",
      content: "Aprenda como identificar links suspeitos, proteger suas informações, verificar páginas antes de inserir dados de pagamento, entender riscos de envio e evitar possíveis golpes ou sites falsos. Sempre verifique a URL do site antes de inserir informações de pagamento ou conta.",
      cta: "Visitar Central de Segurança",
    },
    finalCta: {
      title: "Pronto para explorar o CSSBuy Spreadsheet?",
      content: "Encontre produtos, vendedores e recursos CSSBuy em um só lugar.",
      cta: "Explorar CSSBuy Spreadsheet",
      secondary: "Visitar nosso site principal",
    },
    products: {
      title: "Navegar Produtos",
      subtitle: "Descubra produtos selecionados do nosso catálogo principal",
      viewAll: "Ver Todos os Produtos",
    },
  },
  // Article Page
  article: {
    meta: {
      author: "Equipe CSSBuy Spreadsheet",
      published: "Publicado",
      updated: "Atualizado",
      readingTime: "min de leitura",
    },
    related: "Artigos Relacionados",
    toc: "Sumário",
    cta: "Explorar CSSBuy Spreadsheet",
    comparisonTable: "Tabela de Comparação",
    faqTitle: "FAQ",
    readyToExplore: "Pronto para explorar o CSSBuy Spreadsheet?",
    findResources: "Encontre produtos, vendedores e recursos em um só lugar.",
  },
  // Categories
  categories: [
    { name: "Shoes", slug: "shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { name: "Hoodies/Sweaters", slug: "hoodies", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" },
    { name: "T-Shirts", slug: "t-shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
    { name: "Jackets", slug: "jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
    { name: "Pants/Shorts", slug: "pants", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html" },
    { name: "Headwear", slug: "headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html" },
    { name: "Sets", slug: "sets", url: "https://kaspreadsheet.com/category-917-Sets.html" },
    { name: "Underwear/Underpants", slug: "underwear", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html" },
    { name: "Jersey", slug: "jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html" },
    { name: "Accessories", slug: "accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
    { name: "Bags", slug: "bags", url: "https://kaspreadsheet.com/category-921-Bags.html" },
    { name: "Belts", slug: "belts", url: "https://kaspreadsheet.com/category-922-Belts.html" },
    { name: "Perfumes", slug: "perfumes", url: "https://kaspreadsheet.com/category-923-Perfumes.html" },
    { name: "Other Stuff", slug: "other", url: "https://kaspreadsheet.com/category-924-Other+Stuff.html" },
  ],
  // Articles list
  articlesList: [
    {
      slug: "cssbuy-spreadsheet-2026-complete-guide",
      title: "CSSBuy Spreadsheet 2026: Guia Completo de Produtos e Vendedores",
      desc: "O guia mais completo para usar o CSSBuy Spreadsheet e encontrar produtos, vendedores e recursos de envio em 2026.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-review-2026",
      title: "CSSBuy Review 2026: O CSSBuy é Legítimo e Seguro?",
      desc: "Uma avaliação honesta dos recursos, taxas, segurança e experiência geral do CSSBuy para compradores internacionais em 2026.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-shipping-cost-2026",
      title: "CSSBuy Shipping Cost 2026: Guia Completo de Envio",
      desc: "Uma análise detalhada dos custos de envio do CSSBuy, métodos e dicas para reduzir as taxas de envio internacional.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-warehouse-guide",
      title: "CSSBuy Warehouse Guide: Armazenamento, QC e Envio",
      desc: "Como funciona o armazém do CSSBuy, incluindo armazenamento, verificação de qualidade, consolidação e processamento de envio.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-qc-guide",
      title: "CSSBuy QC Guide: Como Ler Fotos de Controle de Qualidade",
      desc: "Aprenda a ler as fotos de controle de qualidade do CSSBuy para verificar produtos antes do envio internacional.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-coupon-guide",
      title: "CSSBuy Coupon Guide 2026: Como Funcionam os Descontos",
      desc: "Como encontrar e usar cupons, códigos de desconto e promoções do CSSBuy para economizar em taxas e envio.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-buying-guide",
      title: "CSSBuy Buying Guide: Tutorial Completo para Iniciantes",
      desc: "Um tutorial passo a passo para iniciantes, cobrindo desde o primeiro pedido até o recebimento do pacote.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-seller-guide",
      title: "CSSBuy Seller Guide: Como Encontrar Vendedores Confiáveis",
      desc: "Dicas práticas para identificar vendedores confiáveis, avaliar a reputação da loja e evitar erros comuns de compra.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-vs-superbuy",
      title: "CSSBuy vs Superbuy: Qual Serviço Proxy é Melhor?",
      desc: "Uma comparação lado a lado do CSSBuy e do Superbuy cobrindo taxas, envio, armazém e suporte ao cliente.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-product-search-guide",
      title: "CSSBuy Product Search Guide: Como Encontrar Itens",
      desc: "Como pesquisar produtos de forma eficaz usando o CSSBuy Spreadsheet e os filtros de categoria.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-alternatives",
      title: "CSSBuy Alternatives: Melhores Serviços Proxy Comparados",
      desc: "Uma comparação das melhores alternativas ao CSSBuy para compras internacionais por proxy em 2026.",
      date: "2026-08-27",
    },
  ],
  // 404
  notFound: {
    title: "Página Não Encontrada",
    desc: "A página que você está procurando não existe ou foi movida.",
    back: "Voltar ao Início",
  },
  // Products Page
  products: {
    title: "Todos os Produtos",
    subtitle: "Navegue pelo catálogo completo de produtos disponíveis através do CSSBuy Spreadsheet.",
    filterBy: "Filtrar por Categoria",
    allCategories: "Todas as Categorias",
    buyNow: "Comprar Agora",
    showing: "Mostrando",
    products: "produtos",
    noProducts: "Nenhum produto encontrado nesta categoria.",
  },
};